// export default EmiDueReport;
import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import "../css/CgtReport.css";
import { Edit, Trash } from "lucide-react";

const CgtReport = () => {
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // 🔍 Search + Pagination
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

// Static data
  const staticData = [
    {
      cgtId: "cgt1001",
      centerName: "Center A",
      GroupName: "Group A",
      Description: "Example",
      cgtStartDate: "23-3-2025",
      cgtTakenBy: "wealth_officer_name",
    },
   
  ];

// search and filter logic
  const filteredStaticData = useMemo(() => {
    let data = [...staticData];

    if (searchQuery.trim()) {
      data = data.filter((item) =>
        Object.values(item)
          .join(" ")
          .toLowerCase()
          .includes(searchQuery.toLowerCase())
      );
    }

    return data;
  }, [searchQuery]);

// pagination
  const totalPagesFD = Math.ceil(filteredStaticData.length / rowsPerPage);

  const paginatedDataFD = filteredStaticData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <div className="cgt-report-container">
      <h1 className="cgt-report-title">CGT Report</h1>

      {/* Rows per page */}
      <div className="cgt-report-filters">
        <input
          type="text"
          placeholder="Search by any field..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setCurrentPage(1);
          }}
        />

        <label>
          Show{" "}
          <select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>{" "}
          entries
        </label>
      </div>

      {/* Search input */}
      {/* <div className="DDFDReportsearch-box">
        <input
          type="text"
          placeholder="Search by any field..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setCurrentPage(1);
          }}
        />
      </div> */}

      {/* Table */}
      <div className="cgt-report-section">
        <table className="cgt-report-table">
          <thead>
            <tr>
              <th>#</th>
              <th>CGT Id</th>
              <th>Center Name</th>
              <th>Group Name</th>
              <th>Description</th>
              <th>DGT Start Date</th>
              <th>CGT Taken By</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {paginatedDataFD.length === 0 ? (
              <tr>
                <td colSpan="10" className="cgt-report-no-records">
                  ✅ No records found
                </td>
              </tr>
            ) : (
              paginatedDataFD.map((sdata, i) => (
                <tr key={i}>
                  <td>{(currentPage - 1) * rowsPerPage + i + 1}</td>
                  <td>{sdata.cgtId}</td>
                  <td>{sdata.centerName}</td>
                  <td>{sdata.GroupName}</td>
                  <td>{sdata.Description}</td>
                  <td>{sdata.cgtStartDate}</td>
                  <td>{sdata.cgtTakenBy}</td>
                  <td className="cgt-report-btns">
                    <button
                      className="cgt-report-edit-btn"
                      // onClick={() => {
                      //   setIsModalOpen(true);
                      //   setSelectedCustomer(row);
                      // }}
                      title="Edit" // tooltip on hover
                    >
                      <Edit />
                    </button>

                    <button
                      className="cgt-report-delete-btn"
                      // onClick={() => openDeleteDialog(row.id)}
                      title="Delete"
                    >
                      <Trash />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="cgt-report-pagination-btns">
        <button
          onClick={() => setCurrentPage((p) => p - 1)}
          disabled={currentPage === 1}
        >
          ⬅ Previous
        </button>

        <span>
          Page {currentPage} of {totalPagesFD || 1}
        </span>

        <button
          onClick={() => setCurrentPage((p) => p + 1)}
          disabled={currentPage === totalPagesFD || totalPagesFD === 0}
        >
          Next ➡
        </button>
      </div>
    </div>
  );
};

export default CgtReport;
